import { render } from "./AppLayout.vue?vue&type=template&id=259cf514"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import "./AppLayout.vue?vue&type=style&index=0&id=259cf514&lang=scss"
script.render = render

export default script